import {css} from 'styled-components';

// REUSABLE CSS STYLES
export const TextAlign = css`
    text-align: center;
`;

export const Section = css`
    padding: 2rem 0 4rem;
    @media screen and (min-width: 768px){
        padding: 6rem 0 2rem;
    }
`;

export const SectionTitle = css`
    ${TextAlign};
    font-size: var(--h1-font-size);
    
`;

export const SectionSubTitle = css`
    ${TextAlign};
    display: block;
    font-size:var(--small-font-size);
    margin-bottom: var(--mb-3);
    @media screen and (min-width: 768px){
        margin-bottom: 4rem;
}
`;

export const Container = css`
    max-width: 768px;
    margin-left: var(--mb-1-5);
    margin-right: var(--mb-1-5);

    @media screen and (min-width: 768px){
        margin-left: auto;
        margin-right: auto;
    }
`;
export const Grid = css`
   display: grid;
   gap: 1.5rem;
`;

// Button styles
export  const BtnFlex = css`
    display: inline-flex;
    align-items: center;
`;

export const Btn = css`
    background-color: var(--first-color);
    color: #fff;
    padding: 1rem;
    border-radius: .5rem;
    font-weight: var(--font-medium);
    cursor: pointer;
    &:hover{
        background-color: var(--first-color-alt);
    }
    .btn__icon{
        margin-left: var(--mb-0-5);
        transition: .3s;
    }
`;

export const BtnSmall = css`
    padding: .5rem 1rem;
`;

export const BtnLink = css`
    padding: 0;
    background-color: transparent;
    color: var(--first-color); 
    &:hover{
        background-color: transparent;
        color: var(--first-color-alt); 
    }
`;

export const BtnWhite = css`
    background-color: #fff;
    color: var(--first-color);
    &:hover{
        background-color:#fff;
        
    }
`;